import { gql } from "@apollo/client";

export const CREATE_POST = gql`
  mutation CreatePost($data: PostInput!) {
    createPost(data: $data) {
        id
    }
}
`;

export const UPDATE_POST = gql`
  mutation UpdatePost($data: PostInput!,$where: PostWhereInputOne!) {
    updatePost(where: $where, data:$data) {
        id
    }
}
`;

export const DELETE_POST = gql`
  mutation DeletePost($where: PostWhereInputOne!) {
    deletePost(where: $where) {
        id
    }
}
`;

export const START_HOOK_POST = gql`
  mutation StartHookPost($where: PostWhereInputStartHook!) {
    startHookPost(where: $where) {
        id
    }
}
`;

export const STOP_HOOK_POST = gql`
  mutation StopHookPost($where: PostWhereInputOne!) {
    stopHookPost(where: $where) {
        id
    }
}
`;